import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { formatToNumberRound, isEmptyArray } from '../../common/util.services';
import { getEnquiryCosting } from '../costing.services';

const CopyCosting = (props: any) => {

  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const enquiryCode = props.enquiryCode;
  const [costingData, setCostingData] = useState(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, width: 120 },
    { field: 'type', headerName: 'Type', filterable: false, sortable: false, width: 100 },
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, width: 120 },
    { field: 'description', headerName: 'Description', filterable: false, sortable: false, width: 150 },
    { field: 'pack', headerName: 'Pc/Pack', filterable: false, sortable: false, width: 90 },
    { field: 'uom', headerName: 'UOM', filterable: false, sortable: false, width: 100 },
    { 
      field: 'inputCost', headerName: 'Input Cost', filterable: false, sortable: false, width: 100,
      valueFormatter: (inputCost: any) => formatToNumberRound(inputCost)
    },
    { 
      field: 'totalCost', headerName: 'Total Cost', filterable: false, sortable: false, width: 100,
      valueFormatter: (totalCost: any) => formatToNumberRound(totalCost)
    },
    { field: 'owner', headerName: 'Owner', filterable: false, sortable: false, width: 120 },
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getEnquiryCosting(enquiryCode, 0, 100, appContext,
        (response: any) => {
          setCostingData(response.data.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, []);

  const onRowSelection = () => {
    if(selectedRows.length < 1) {
      appContext.setDialogMessage('Select a row.');
    }
    else if (props.onRowSelection) {
      props.onRowSelection(selectedRows);
    }
  }
  
  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = costingData.filter((row) =>
      selectedIds.has(row.rowId)
    );
    setSelectedRows(selectedRowData);
  }

  return <div className='master-detail'>
    <IGridComponent title='' showAddBtn={false} rows={costingData} columns={columns} maxHeight={"50vh"}
      getRowId={(row: any) => row.rowId} disableMultipleRowSelection={true} loading={loading} hideFooterPagination={true}
      showExtBtn={true} extBtnText={'Copy'} extBtnAction={onRowSelection}
      checkboxSelection={true} disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange} />
  </div>
}

export default CopyCosting;